'use client';

import React, { createContext, useContext, useEffect, useState } from 'react';
import type { PropsWithChildren } from 'react';
import type { Nullable } from 'corgi-types';

export type WishlistState = { wishlistedItems: Set<string> };

type WishlistProviderProps = PropsWithChildren<{ state: Nullable<WishlistState> }>;

const WishlistContext = createContext(null);

export const WishlistProvider = ({ state, children }: WishlistProviderProps) => {
  const [wishlistState, setState] = useState(state);

  return (
    <WishlistContext.Provider value={{ state: wishlistState, setState }}>
      {children}
    </WishlistContext.Provider>
  );
};

export type WishlistProviderContext = {
  state: WishlistState;
  setState: (arg: WishlistState) => void;
};

export const useWishlistContext = (): Nullable<WishlistProviderContext> =>
  useContext(WishlistContext);

export const useUpdateWishlistState = (wishlistState: WishlistState) => {
  const wishlistContext = useWishlistContext();

  useEffect(() => {
    if (wishlistContext) wishlistContext.setState(wishlistState);
  }, [wishlistContext, wishlistState]);
};
